import axios from "axios";
import { generateDrawdownReport } from "../pages/publicMap/controls/DrawdownToolControl/utils/drawdownDocumentGenerator";
import { DRAWDOWN_API_ENDPOINTS } from "../pages/publicMap/controls/DrawdownToolControl/constants/drawdownConstants";

const ENDPOINT = process.env.REACT_APP_ENDPOINT;

// Helper function to get auth headers
const getAuthHeaders = async (getAccessTokenSilently, isAuthenticated) => {
  let headers = {};
  if (isAuthenticated) {
    const token = await getAccessTokenSilently();
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

const drawdownService = {
  // Get aquifer options
  async getAquifers(getAccessTokenSilently, isAuthenticated) {
    const headers = await getAuthHeaders(
      getAccessTokenSilently,
      isAuthenticated
    );
    const response = await axios.get(
      `${ENDPOINT}${DRAWDOWN_API_ENDPOINTS.AQUIFERS}`,
      { headers }
    );
    return response.data;
  },

  // Get unit options
  async getUnits(getAccessTokenSilently, isAuthenticated) {
    const headers = await getAuthHeaders(
      getAccessTokenSilently,
      isAuthenticated
    );
    const response = await axios.get(
      `${ENDPOINT}${DRAWDOWN_API_ENDPOINTS.UNITS}`,
      { headers }
    );
    return response.data;
  },

  // Submit new analysis run
  async submitRun(data, getAccessTokenSilently, isAuthenticated) {
    const headers = await getAuthHeaders(
      getAccessTokenSilently,
      isAuthenticated
    );
    const response = await axios.patch(
      `${ENDPOINT}${DRAWDOWN_API_ENDPOINTS.PROPOSED_WELL}`,
      data,
      { headers }
    );
    return response.data;
  },

  // Get list of previous runs
  async getRuns(getAccessTokenSilently, isAuthenticated) {
    const headers = await getAuthHeaders(
      getAccessTokenSilently,
      isAuthenticated
    );
    const response = await axios.get(
      `${ENDPOINT}${DRAWDOWN_API_ENDPOINTS.RUNS}`,
      { headers }
    );
    return response.data;
  },

  // Get run details
  async getRunDetails(runNdx, getAccessTokenSilently, isAuthenticated) {
    const headers = await getAuthHeaders(
      getAccessTokenSilently,
      isAuthenticated
    );
    const response = await axios.get(
      `${ENDPOINT}${DRAWDOWN_API_ENDPOINTS.RUN_DETAILS(runNdx)}`,
      { headers }
    );
    return response.data;
  },

  // Get run results
  async getRunResults(runNdx, getAccessTokenSilently, isAuthenticated) {
    const headers = await getAuthHeaders(
      getAccessTokenSilently,
      isAuthenticated
    );
    const response = await axios.get(
      `${ENDPOINT}${DRAWDOWN_API_ENDPOINTS.RUN_RESULTS(runNdx)}`,
      { headers }
    );
    return response.data;
  },

  // Generate and download Word document report
  async downloadReport(runNdx, getAccessTokenSilently, isAuthenticated) {
    const headers = await getAuthHeaders(
      getAccessTokenSilently,
      isAuthenticated
    );

    // Fetch run details and report data
    const [runDetailsResponse, reportDataResponse] = await Promise.all([
      axios.get(`${ENDPOINT}${DRAWDOWN_API_ENDPOINTS.RUN_DETAILS(runNdx)}`, {
        headers,
      }),
      axios.get(`${ENDPOINT}${DRAWDOWN_API_ENDPOINTS.RUN_REPORT(runNdx)}`, {
        headers,
      }),
    ]);

    const runDetails = runDetailsResponse.data;
    const reportData = reportDataResponse.data;

    // Generate and download the Word document
    generateDrawdownReport(runDetails, reportData);
  },

  // Delete a run
  async deleteRun(runNdx, getAccessTokenSilently, isAuthenticated) {
    const headers = await getAuthHeaders(
      getAccessTokenSilently,
      isAuthenticated
    );
    const response = await axios.delete(
      `${ENDPOINT}${DRAWDOWN_API_ENDPOINTS.DELETE_RUN(runNdx)}`,
      { headers }
    );
    return response.data;
  },
};

export default drawdownService;
